import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import queryString from 'query-string';

class ColisMessagerie extends React.Component {

    constructor(props) {
        super(props);
        var inputs = {};
        this.state = {
            titlepage: "Nouveau colis",
            inputs: inputs,
            liste_regions: [],
            liste_sellers: [],
            liste_pages: [],
            liste_grand_cities: [],
            liste_cities: [],
            all_liste_grand_cities: [],
            all_liste_cities: [],
        }
    }

    submit = () => {
        const inputs = this.state.inputs;
        let formData = new FormData();
        const current_time = this.props.current_time;
        
        var keysinputs = Object.keys(inputs);
        keysinputs.forEach(function(element,keyelemnt){
            formData.append(element, inputs[element]);
        
        });
        
        fetch(api_route('save-colis-ecommerce'), { method: 'POST', body: formData })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                }
                if (resp.response === 'error') {
                    alertify.error(resp.message);
                } else if (resp.response === 'success') {
                    var inputs = {};
                    this.setState({ inputs: inputs }, function () {
                        alertify.success(resp.message);
                        this.props.setCurrentPage('');
                        this.props.history.push("/colis/shipped?statut_colis=waiting-pick-up&t="+current_time);
                    });
                }
            })
           .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })
    }
    
     componentDidMount() {
        this.props.setCurrentPage('save_colis');
        window.scrollTo(0, 0);
        var params = queryString.parse(this.props.location.search);
        var colis_id = params.colis_id;
        
        if(colis_id){
            this.props.loaderDisplay(true);
            
            fetch(api_route('infos-colis') + '&colis_id=' + colis_id, { method: 'GET' })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                } else if (resp['infos_colis']) {
                    const infos_colis = resp['infos_colis'];
                    
                    // Inputs
                    const inputs = this.state.inputs;
                    inputs["row_colis"] = infos_colis;
                    inputs["colis_id"] = infos_colis.colis_id;
                    inputs["price"] = infos_colis.price;
                    inputs["description"] = infos_colis.description;
                    inputs["number_shipments"] = infos_colis.number_shipments;
                    inputs["poids"] = infos_colis.poids;
                    inputs["valeur"] = infos_colis.valeur;
                    inputs["mode_livraison"] = infos_colis.mode_livraison;
                    inputs["mode_paiement"] = infos_colis.mode_paiement;
                    inputs["type_paiement"] = infos_colis.type_paiement;
                    inputs["recipient_name"] = infos_colis.recipient_name;
                    inputs["comment_seller"] = infos_colis.comment_seller;
                    inputs["recipient_phone"] = infos_colis.recipient_phone;
                    inputs["recipient_city"] = infos_colis.recipient_city;
                    inputs["page_id"] = infos_colis.page_id;
                    inputs["recipient_address"] = infos_colis.recipient_address;
                    inputs["page_id"] = infos_colis.page_id;
                    inputs["region_id"] = infos_colis.region_id;
                    inputs["grand_cities_id"] = infos_colis.grand_cities_id;
                    this.setState({ inputs: inputs });
                    this.setState({ titlepage: "Colis N° "+infos_colis.barecode });
                    
                    this.props.loaderDisplay(false);
                }
            })
           .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })    
        }
        
        // Cities List
        fetch(api_route('liste-cities'), { method: 'GET' })
        .then(resp => resp.json())
        .then(resp => {
            if (resp.response === 'error-connected') {
                user_logout();
                this.props.history.push(`/user-logout`);
            } else {
                this.setState({ liste_regions: resp['liste_regions'] });
                this.setState({ all_liste_grand_cities: resp['liste_grandcities'] });
                this.setState({ all_liste_cities: resp['liste_cities'] });
                this.setState({ liste_pages: resp['liste_pages'] });
                this.RefreshDataGrandCities(this.state.inputs.region_id);
                this.RefreshDataCities(this.state.inputs.grand_cities_id);
            }
        })
       .catch(err => {
            this.props.loaderDisplay(false);
            this.props.openErrorSystem(true);
        }) 

        // Cities List
        fetch(api_route('liste-sellers'), { method: 'GET' })
        .then(resp => resp.json())
        .then(resp => {
            if (resp.response === 'error-connected') {
                user_logout();
                this.props.history.push(`/user-logout`);
            } else {
                this.setState({ liste_sellers: resp['liste_sellers'] });
            }
        })
       .catch(err => {
            this.props.loaderDisplay(false);
            this.props.openErrorSystem(true);
        })
    }

    render() {
        const inputs = this.state.inputs;
        const livreur = this.props.livreur;
        
        const liste_pages = this.state.liste_pages;
        var keypages = Object.keys(liste_pages);
        
        const liste_regions = this.state.liste_regions;
        var keyregions = Object.keys(liste_regions);

        const liste_grand_cities = this.state.liste_grand_cities;
        var keygrand_cities = Object.keys(liste_grand_cities);
        
        const all_liste_cities = this.state.all_liste_cities;
        var keycities = Object.keys(all_liste_cities);

        const liste_sellers = this.state.liste_sellers;
        var keysellers = Object.keys(liste_sellers);
        
        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity">
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">{this.state.titlepage}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="row">
                    <div className="container">
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Expéditeur</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                         <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Vendeur <span class="text-danger">*</span></label>
                                                <select className="form-control" name="seller_id" onChange={this.AfterChangeSellers}>
                                                    <option selected value="">Nouveau vendeur</option>
                                                    {keysellers.map((element, index) => {
                                                        return <option selected={liste_sellers[element]['id'] == inputs.region_id} value={liste_sellers[element]['id']}>{liste_sellers[element]['name']}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Nom <span style={{ color: 'red' }}>*</span></label>
                                                <input type="text" name="seller_name" className="form-control" onChange={this.inputHandling} value={inputs.seller_name} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Téléphone <span style={{ color: 'red' }}>*</span></label>
                                                <input type="number" name="seller_phone" className="form-control" onChange={this.inputHandling} value={inputs.seller_phone} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Quartier <span class="text-danger">*</span></label>
                                                <select className="form-control" name="seller_city">
                                                    <option selected value="">Ville</option>
                                                    {keycities.map((element, index) => {
                                                        return <option selected={all_liste_cities[element]['id'] == inputs.seller_city} value={all_liste_cities[element]['id']}>{all_liste_cities[element]['name']}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Destinataire</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Nom <span style={{ color: 'red' }}>*</span></label>
                                                <input type="text" name="recipient_name" className="form-control" onChange={this.inputHandling} value={inputs.recipient_name} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Téléphone <span style={{ color: 'red' }}>*</span></label>
                                                <input type="number" name="recipient_phone" className="form-control" onChange={this.inputHandling} value={inputs.recipient_phone} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Régions <span class="text-danger">*</span></label>
                                                <select className="form-control" name="region_id" onChange={this.AfterChangeRegions}>
                                                    <option value="">Choisissez votre région</option>
                                                    {keyregions.map((element, index) => {
                                                        return <option selected={liste_regions[element]['id'] == inputs.region_id} value={liste_regions[element]['id']}>{liste_regions[element]['name']}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Ville <span class="text-danger">*</span></label>
                                                <select className="form-control" name="grand_cities_id" onChange={this.AfterChangeGrandCities}>
                                                    <option selected value="">Choisissez votre ville</option>
                                                     {keygrand_cities.map((element, index) => {
                                                        return <option selected={liste_grand_cities[element]['id'] == inputs.grand_cities_id} value={liste_grand_cities[element]['id']}>{liste_grand_cities[element]['name']}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>  

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Quartier <span class="text-danger">*</span></label>
                                                <select className="form-control" name="recipient_city" onChange={this.inputHandling}>
                                                    <option selected value="">Choisissez votre quartier</option>
                                                    { this.state.liste_cities.map((element, index) => {
                                                        return <option selected={element == inputs.recipient_city} value={element}>{element}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Adresse <span style={{ color: 'red' }}>*</span></label>
                                                <input type="text" name="recipient_address" className="form-control" onChange={this.inputHandling} value={inputs.recipient_address} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>

                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Informations du colis</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Nombre de colis <span style={{ color: 'red' }}>*</span></label>
                                                <input type="number" name="number_shipments" className="form-control" onChange={this.inputHandling} value={inputs.number_shipments} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Poids total <span style={{ color: 'red' }}>*</span></label>
                                                <input type="number" name="poids" className="form-control" onChange={this.inputHandling} value={inputs.poids} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Valeur</label>
                                                <input type="number" name="valeur" className="form-control" onChange={this.inputHandling} value={inputs.valeur} />
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Description</label>
                                                <input type="text" name="description" className="form-control" onChange={this.inputHandling} value={inputs.description} />
                                            </div>
                                        </div>
            
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Lieu de livraison <span style={{ color: 'red' }}>*</span></label>
                                                <select className="form-control" name="mode_livraison" onChange={this.inputHandling}>
                                                    <option value="">Lieu de livraison </option>
                                                    <option 
                                                        selected={"gare" == inputs.mode_livraison}
                                                        value="gare">En gare</option>
                                                    <option 
                                                        selected={"domicile" == inputs.mode_livraison}
                                                        value="domicile">À Domicile</option>
                                                </select>
                                            </div>
                                        </div>
            
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Qui devrait le payer la livraison <span style={{ color: 'red' }}>*</span></label>
                                                <select className="form-control" name="mode_paiement" onChange={this.inputHandling}>
                                                    <option value="">Qui devrait le payer</option>
                                                    <option 
                                                        selected={"expediteur" == inputs.mode_paiement}
                                                        value="expediteur">Moi</option>
                                                    <option 
                                                        selected={"destinataire" == inputs.mode_paiement}
                                                        value="destinataire">Destinataire</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Contre versement</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Montant total</label>
                                                <input type="number" name="price" className="form-control" onChange={this.inputHandling} value={inputs.price} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Mode de paiement </label>
                                                <select className="form-control" name="type_paiement" onChange={this.inputHandling}>
                                                    <option value="">Mode de paiement </option>
                                                    <option 
                                                        selected={"espece" == inputs.type_paiement}
                                                        value="espece">Espèce</option>
                                                    <option 
                                                        selected={"cheque" == inputs.type_paiement}
                                                        value="cheque">Chèque</option>
                                                    <option 
                                                        selected={"traite" == inputs.type_paiement}
                                                        value="traite">Traite</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <div className="card-footer">
                                {inputs.colis_id && (
                                    <div className="row mt-4 mb-4">
                                        <div className="col">
                                            <button className="btn-lcolis buynow btn btn-primary text-uppercase" onClick={() => this.submit()}>Modifier <i className="material-icons md-18 ml-1">edit</i></button>

                                            <button className="btn-lcolis buynow btn btn-danger text-uppercase" onClick={() => this.openConfirmModal(true, inputs.row_colis)}>Supprimer <i className="material-icons md-18 ml-1">delete</i></button>
                                        </div>
                                    </div>
                                )} 

                                {!inputs.colis_id && (
                                    <div className="row mt-4 mb-4">
                                        <div className="col">
                                            <button className="btn-lcolis buynow btn btn-primary text-uppercase" onClick={() => this.submit()}>Ajouter <i className="material-icons md-18 ml-1">add</i></button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                       
                    </div>
                </div>

            </React.Fragment>
        );
    }

    inputHandling = (event) => {
        const target = event.target;
        const inputs = this.state.inputs;
        inputs[target.name] = target.value;
        this.setState({ inputs: inputs });
    }


    AfterChangeRegions = (event) => {
        const target = event.target;
        const inputs = this.state.inputs;
        this.RefreshDataGrandCities(target.value)       
    }


    AfterChangeGrandCities = (event) => {
        const target = event.target;
        const inputs = this.state.inputs;
        this.RefreshDataCities(target.value);
       
    } 

    AfterChangeSellers = (event) => {
        const target = event.target;
        if(target){

        }else{
            
        }
       
    }

    RefreshDataGrandCities = (val_id) => {
        var liste_val_grandcities = [];
        this.state.all_liste_grand_cities.forEach(function(element){
            if(element.region_id == val_id){
                liste_val_grandcities.push(element);
            }
        })

        this.setState({
            liste_grand_cities: liste_val_grandcities,
            liste_cities: []
        })
    }

    RefreshDataCities = (val_id) => {
        var liste_val_cities = [];
        this.state.all_liste_cities.forEach(function(element){
            if(element.grand_cities_id == val_id){
                liste_val_cities.push(element.name);
            }
        })

        this.setState({
            liste_cities: liste_val_cities
        })
    }

    openConfirmModal = (v, coli = null) => {
        this.props.showModal('remove_colis', coli)
    } 
}

export default withRouter(ColisMessagerie);